import { render, staticRenderFns } from "./DAUploadFile.vue?vue&type=template&id=36137ef2&scoped=true"
import script from "./DAUploadFile.vue?vue&type=script&lang=js"
export * from "./DAUploadFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36137ef2",
  null
  
)

export default component.exports